@if (showSpinner) {
  <mat-spinner></mat-spinner>
} @else {
  @for (cachedUser of cachedUsers; track cachedUser; let last = $last) {
    <div class="session-list__cached-user" [ngClass]="{ 'session-list__cached-user--last': last }">
      <button class="session-list__user-login-button"
        (click)="login(cachedUser)">
        <span class="session-list__user-login-button-label">{{ cachedUser.nickname }}</span>
        @if (cachedUser.picture) {
          <img
            class="session-list__user-login-button-image"
            [src]="cachedUser.picture"
            aria-hidden="true">
        }
      </button>
      <button class="session-list__remove-user-button"
        (click)="deleteCachedUser(cachedUser)"
        [attr.aria-label]="'generic.delete' | translate">
        <mat-icon svgIcon="trash"
          alt="supprimer">
        </mat-icon>
      </button>
    </div>
  }
  <div>
    <button class="session-list__new-login-button"
      (click)="login(null)">
      {{ "authentication.login_other_account" | translate }}
    </button>
  </div>
}

